import { Alert, Card, CardContent, CardHeader, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Commons } from "../../helper/CommonService";
import { CONFIG_PENDAFTARAN, JENIS_BAYAR, STATUS_PROGRESS } from "../../helper/Constant";
import dayjs from "dayjs";

function DetailPembayaran({dataSantri, dataBayar, dataJenjangTujuan }) {
    const detailPembayaranReg = dataBayar?.find((x) => x.type === JENIS_BAYAR.PENDAFTARAN);
    const detailPembayaranReReg = dataBayar?.find((x) => x.type === JENIS_BAYAR.DAFTAR_ULANG);
    const [infoBayar, setInfoBayar] = useState();
    const [lastUangDaftar, setLastUangDaftar] = useState();
    const [uangDaftar, setUangDaftar] = useState();
    const [uangDaftarUlang, setUangDaftarUlang] = useState();
    const [lastUangDaftarUlang, setLastUangDaftarUlang] = useState();

    useEffect(() => {
        Promise.all(
            [
                Commons.GetAdditionalInformation(CONFIG_PENDAFTARAN.INFO_PEMBAYARAN),
                Commons.GetAdditionalInformation(CONFIG_PENDAFTARAN.TGL_UANG_DAFTAR_TERAKHIR),
                Commons.GetAdditionalInformation(CONFIG_PENDAFTARAN.UANG_PENDAFTARAN),
                Commons.GetAdditionalInformation(CONFIG_PENDAFTARAN.UANG_DAFTAR_ULANG),
                Commons.GetAdditionalInformation(CONFIG_PENDAFTARAN.TGL_UANG_DAFTAR_ULANG_TERAKHIR)
            ]
        )
            .then(([respInfoBayar, respLastUangDaftar, respUangDaftar, respUangDaftarUlang, respLastDaftarUlang]) => {
                setInfoBayar(respInfoBayar);
                setLastUangDaftar(respLastUangDaftar);
                setUangDaftar(respUangDaftar);
                setUangDaftarUlang(respUangDaftarUlang);
                setLastUangDaftarUlang(respLastDaftarUlang);
            });
    }, []);

    const StatusBayarRegisterView = () => {
        if (detailPembayaranReg && detailPembayaranReg?.isLunas) {
            return (
                <>
                    <Typography variant="h6" component="div" sx={{ mb: 2 }}>
                        Pembayaran Biaya Pendaftaran
                    </Typography>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Status Pembayaran
                                    </TableCell>
                                    <TableCell align="left">
                                        : <b>Lunas</b>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Nominal
                                    </TableCell>
                                    <TableCell align="left">
                                        : <b>{detailPembayaranReg?.nominal}</b>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Tanggal
                                    </TableCell>
                                    <TableCell align="left">
                                        : <b>{(detailPembayaranReg && detailPembayaranReg.tanggal) ? dayjs(detailPembayaranReg.tanggal).format("YYYY-MM-DD") : '-'}</b>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        No. Kuitansi
                                    </TableCell>
                                    <TableCell align="left">
                                        : <b>{detailPembayaranReg?.no_kuitansi}</b>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Metode
                                    </TableCell>
                                    <TableCell align="left">
                                        : <b>{detailPembayaranReg?.metode}</b>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Catatan
                                    </TableCell>
                                    <TableCell align="left">
                                        :<b>{detailPembayaranReg?.catatan}</b>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            );
        }

        return (
            <Alert title="Segera Transfer" variant="filled" severity="success" sx={{ marginBottom: "15px" }}>
                Harap segera melakukan transfer uang pendaftaran sebesar {uangDaftar + " "}
                {infoBayar} paling lambat {lastUangDaftar} pukul 23:59 WIB.
            </Alert>
        )

    }

    const StatusBayarReRegisterView = () => {
        if (detailPembayaranReReg && detailPembayaranReReg.isLunas) {
            return (
                <>
                    <Typography variant="h6" component="div" sx={{ mb: 2 }}>
                        Pembayaran Biaya Daftar Ulang
                    </Typography>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Status Pembayaran
                                    </TableCell>
                                    <TableCell align="left">
                                        : <b>Lunas</b>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Nominal
                                    </TableCell>
                                    <TableCell align="left">
                                        : <b>{detailPembayaranReReg?.nominal}</b>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Tanggal
                                    </TableCell>
                                    <TableCell align="left">
                                        : <b>{(detailPembayaranReReg && detailPembayaranReReg.tanggal) ? dayjs(detailPembayaranReReg.tanggal).format("YYYY-MM-DD") : '-'}</b>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        No. Kuitansi
                                    </TableCell>
                                    <TableCell align="left">
                                        : <b>{detailPembayaranReReg?.no_kuitansi}</b>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Metode
                                    </TableCell>
                                    <TableCell align="left">
                                        : <b>{detailPembayaranReReg?.metode}</b>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        Catatan
                                    </TableCell>
                                    <TableCell align="left">
                                        :<b>{detailPembayaranReReg?.catatan}</b>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            );
        }
        if ( dataSantri.status === STATUS_PROGRESS.PENGUMUMAN) {
            return (
                <Alert title="Segera Transfer" variant="filled" severity="success" sx={{ marginBottom: "15px" }}>
                    Harap segera melakukan transfer uang Pendaftaran Ulang sebesar {Commons.GetUangDaftarUlang(dataJenjangTujuan, uangDaftarUlang) + " "}
                    {infoBayar} paling lambat {lastUangDaftarUlang} pukul 23:59 WIB.
                </Alert>
            );
        }
    }
    return (
        <>
            <Card>
                <CardHeader title="Status Pembayaran" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    {StatusBayarRegisterView()}
                    <br></br>
                    {StatusBayarReRegisterView()}
                </CardContent>
            </Card>

        </>
    )
}

export default DetailPembayaran;